var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 737,
    viewBox: "0 0 474 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.5 1C308.449 1 473 165.551 473 368.5C473 571.449 308.449 736 105.5 736C-97.4486 736 -262 571.449 -262 368.5C-262 165.551 -97.4486 1 105.5 1Z",
    stroke: "#FFEF00",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.283 558.814C324.534 558.814 443.932 440.049 443.932 294.549C443.932 149.049 324.534 30.0677 178.283 30.0677C32.0318 30.0677 -87.5938 148.832 -87.5938 294.56C-87.5938 440.287 31.7926 558.825 178.283 558.825V558.814Z",
    stroke: "#00A8E1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5119 706.932C180.21 706.932 299.972 588.168 299.972 442.667C299.972 297.167 180.221 178.175 33.5119 178.175C-113.197 178.175 -232.938 296.951 -232.938 442.667C-232.938 588.384 -113.415 706.932 33.5228 706.932H33.5119Z",
    stroke: "#FF5C00",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.af309208c9195cf64575916332b80268.svg";
export { ForwardRef as ReactComponent };